'use strict';

/**
 * Component for the locality selection
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var Html = require('base/Colido.Html');
var Awesomplete = require('vendor/awesomplete');

var template = require('../../templates/components/field-locality.hbs');

var LocalityComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'localityInput': 'textarea[name="locality"]',
    },

    events: {
        'keyup @ui.localityInput': 'checkLocalityStringLive',
        'change @ui.localityInput': 'checkLocalityString',
        'blur @ui.localityInput': 'checkLocalityString',
        'input @ui.localityInput': 'onInputLocalityField',
        'awesomplete-selectcomplete @ui.localityInput': 'onAwesompleteSelectComplete',
    },

    /**
     * Reference to awesomplete
     * @type {Awesomplete}
     */
    awesomplete: null,

    /**
     * Internal cache
     * @type {Object}
     */
    awesompleteCache: {},

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        fullLocality: function() {
            var field = this.getOption('field');
            var locality = this.model.get(field.name);

            return locality ? locality.full : '';
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    /**
     * Remove hidden input
     * @return {void}
     */
    onBeforeDestroy: function() {
        this.$el.off();
        this.ui.localityInput.off();
    },

    onAttach: function() {
        var field = this.getOption('field');

        // Init awesomplete
        this.awesomplete = new Awesomplete(this.ui.localityInput[0], {
            minChars: 1,
            maxItems: 6,
            list: [],
        });

        // Add small class
        this.$('.awesomplete').addClass('awesomplete--small');

        // Check autosize textarea
        this.fixTextareaSize(this.ui.localityInput);

        // Do we have a value?
        var locality = this.model.get(field.name);
        if (locality) {
            this.setProperLocalityValue(this.ui.localityInput, locality.full);
        }
    },

    onResize: function() {
        this.fixTextareaSize(this.ui.localityInput);
    },

    /**
     * Is triggered, when the user inputs something into the locality field
     * @param {object} event The input event
     */
    onInputLocalityField: function(event) {
        // Get value without breaks
        var val = this.ui.localityInput.val().replace(/[\r\n]+/gm, ' ').replace(/[\s]{2,}/g, ' ');

        // Process response from api or cache
        if (this.awesompleteCache[val]) {
            this.processAutocompleteResponse(this.awesompleteCache[val]);
        } else {
            var request = $.getJSON(App.getApiUrl('/localities/name/' + val + '*'));
            request.done(function(response) {
                this.awesompleteCache[val] = response;
                this.processAutocompleteResponse(response);
            }.bind(this));
        }
    },

    /**
     * Processes the response from API or cache
     * @param {object} response The response object, containing autocomplete items
     */
    processAutocompleteResponse: function(response) {
        if (this.awesomplete) {
            this.awesomplete.list = _.pluck(_.values(response), 'displayPath');
            this.awesomplete.evaluate();
        }
    },

    /**
     * Is triggered, when the user selects a value from autocomplete
     * @param {object} event The select complete event from awesomplete
     */
    onAwesompleteSelectComplete: function(event) {
        this.setProperLocalityValue(this.ui.localityInput);
        if (this.awesomplete) {
            this.awesomplete.close();
        }
    },

    /**
     * Checks the locality string on keyup event
     * @param {object} event The keyup event
     */
    checkLocalityStringLive: function(event) {
        // Do not run, when arrow key is pressed
        if (!_.contains([
                App.keys.UPARROW,
                App.keys.LEFTARROW,
                App.keys.RIGHTARROW,
                App.keys.DOWNARROW,
            ], event.which)
        ) {
            // Call autocompleter
            if (event.which !== App.keys.RETURN) {
                this.onInputLocalityField(event);
            }

            // Get proper values
            var textarea = $(event.currentTarget);
            var val      = this.ui.localityInput.val().replace(/\r/gm, '');

            // Format, if we have comma or return
            if (_.contains([App.keys.RETURN, App.keys.COMMA, App.keys.COMMA_SECONDARY], event.which)) {
                var caretPosition = Html.getCaretPosition(textarea[0]);

                // We have a comma
                if (event.which === App.keys.COMMA || event.which === App.keys.COMMA_SECONDARY) {
                    var start = val.substr(0, caretPosition);
                    var end   = val.substr(caretPosition, val.length - caretPosition);

                    textarea.val(start + '\n' + end);
                    Html.setCaretPosition(textarea[0], caretPosition + 1);
                }

                // We have a return
                if (event.which === App.keys.RETURN) {
                    if (val.substr(caretPosition - 1, 1) === '\n') {
                        var start = val.substr(0, caretPosition - 1);
                        var end   = val.substr(caretPosition - 1, val.length - caretPosition - 1);

                        var insertComma = start.substr(-1) !== ',';

                        if (end.length == 0) {
                            textarea.val(start + (insertComma ? ',\n' : '\n') + end);
                        } else {
                            textarea.val(start + (insertComma ? ',' : '') + end);
                            Html.setCaretPosition(textarea[0], caretPosition + (insertComma ? 1 : 0));
                        }
                    }
                }
            }

            // Resize textarea
            this.fixTextareaSize(this.ui.localityInput);
        }
    },

    /**
     * Checks the locality string, when something has changed
     * @param {object} event The change vent
     */
    checkLocalityString: function(event) {
        var $curTarget = $(event.currentTarget);
        this.setProperLocalityValue($curTarget);
    },

    /**
     * Sets the proper value for the locality input
     * @param {object}  textarea The jquery textarea object
     * @param {string=} value    The value to set
     */
    setProperLocalityValue: function(textarea, value) {
        value = value || textarea.val();

        textarea.val(this.getFormattedValue(value));
        this.fixTextareaSize(textarea);
    },

    /**
     * Returns the formatted string for the locality
     * @param {string} string The input string
     * @returns {string} The formattes string
     */
    getFormattedValue: function(string) {
        var formattedTokens = [];

        var tokens = string.trim()
            .replace(/,$/, '') // Remove last comma
            .replace(/\r/gm, '') // Remove carriage returns
            .replace(/,{2,}/gm, ',') // Remove double commas
            .split(',');

        _.each(tokens, function(token) {
            token = token.trim();

            if (token.length) {
                formattedTokens.push(token);
            }
        });

        return formattedTokens.join(',\n').trim();
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');
        var localityString = this.ui.localityInput.val().trim();

        data[field.name] = {
            full: localityString,
        };

        return data;
    },
});

module.exports = LocalityComponent;